import { useMemo } from "react"
import { getIn, useFormikContext } from "formik"
import * as Yup from 'yup'

import { FormikFileUpload, FormikNotesArea } from "../../../../../../components/widgets"
import { DLMGenerateDOCButton } from "../components"
import { DLMCreateDOCButton } from "../../../widgets/DLMCreateDOCButton"
import { ID } from "../../../../../../../_metronic/helpers"
import { isPopulatedArray, isValidString } from "../../../../../../components/helpers"
import { DOC_MODEL_CHECK_FIELDS } from "../../../../../core/doclabel"
import { IWebFileAttachment } from "../../../../../core/applications"
import { sortBy } from "lodash"

interface DOCModelItem {
  docId: number
  docAttachmentId: number
  docAttachmentIdAttachmentName: string
}

// Site Inspection
export interface IDLMSubmitDOC  {
  docModels: Array<DOCModelItem>
  note: string
  noteAttachments: Array<IWebFileAttachment>
}

export const initDLMSubmitDOCValues: IDLMSubmitDOC = {
  docModels: [],
  note: '',
  noteAttachments: [],       
}

export const DLMSubmitDOCSchema: any = Yup.object({
  docModels: Yup.array().required().min(1,'DOC Attachment Required').of(
    Yup.object().shape({
      docId: Yup.number().integer().label('DOC Id'),
      docAttachmentId: Yup.number().integer().integer().moreThan(0,'DOC required').required().label('DOC Attachment'),
      docAttachmentIdAttachmentName: Yup.string().trim(),
    })
  ),
  note: Yup.string().trim().label('Note'),
  noteAttachments: Yup.array(),  
});

type Props = {
  appID: ID
}

export const DLMSubmitDOCForm = ({appID} : Props) => {

  const { values, validateField, setFieldValue } = useFormikContext();
  const { docModels, hasMissing } = useMemo(() => {
    if (! (values)) return { docModels: [], hasMissing : true };
    const docModels = getIn(values, 'docModels');    

    if (! isPopulatedArray(docModels)) return { docModels: [], hasMissing : true };
    
    let hasMissing = false;
    docModels.forEach( (doc: any) => {
      DOC_MODEL_CHECK_FIELDS.forEach( fld => {
        if (! isValidString(doc[fld])) {
          hasMissing = true;
        }
      })      
    });
    
    return { docModels, hasMissing };
  }, [values]);

  const setDOCModel = (obj: any, idx: number) => {
      
    if (! (obj && typeof(obj) === 'object' && obj?.docId)) return;

    setFieldValue(`docModels.${idx}`, {
      ...obj,
      docAttachmentId: 0,
      docAttachmentIdAttachmentName: ''
    }, true);        
  }

  if (! appID) {
    return null;
  }

  return (
  <>        
  <div className="row">
    <div className="col-5">
      <h4>Upload DOC:</h4>        
    </div>
    {(! docModels?.length) && 
    <div className="col-7 text-end">
      <DLMCreateDOCButton appID={appID} />
    </div>        
    }    
  </div>
  
  
  <div className='text-muted fs-7'>For COC Holder Endorsement</div>                           
  <div className='separator border-gray-200 mb-2'></div>        
  { ((!hasMissing) && docModels && docModels.length > 0) &&
  <>
  {sortBy(docModels,'cbRef').map((docModel: any, idx: number) => (
  <div className="row" key={`docgen_${idx}`}>       
    <div className="col-4 mt-1 py-2">
      <DLMGenerateDOCButton index={idx} onGenDOC={setDOCModel} baseData={docModel} hasIssueDate={true} />
    </div>    
    <FormikFileUpload 
      size="8" 
      label={`${docModel?.cbRef ? docModel.cbRef : "DOC Attachment"}`}
      name={`docModels.${idx}.docAttachmentId`} 
      acceptFiles="UserFileFormats" 
      required={true} 
      disabled={(docModel?.docId) ? false : true} 
      subTitle={(docModel?.docId) ? "Upload DOC here" : "Generate DOC first."}
      onUpdateFunc={() => {
        setTimeout(() => {
          validateField('docModels');                    
        }, 100)                 
      }}
    />
  </div>    
  ))}
  </>
  }       
  <div className='separator border-gray-200 mb-2'></div>
  <FormikNotesArea />
  </>
  )
}
